import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import { $contentLoading } from './skeleton'

const skin = era.skin('routes/library/purchased/tvChannels')

LibraryPurchasedTvChannelsPage.displayName = 'LibraryPurchasedTvChannelsPage'
export function LibraryPurchasedTvChannelsPage(): JSX.Element {
  const isContentLoading = useUnit($contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={`flex-column`}>
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='libraryPurchasedTvChannelsGrid' />
          <ui.RenderSkin name='libraryPurchasedTvChannelsEmptyPage' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
